import React from "react";

const CompanyProfile = () => {
  return (
    <div className='main-container'>
      <h1 className='title'>Company Profile</h1>
      <div className='description'>
        The financial devastation that often results from the sudden onset of a
        major illness or an accidental injury suffered by the ordinary employee
        is a commonly shared concern by both the latter’s family and his
        employer. The realities of the times, however, often make the setting
        aside of the financial resources needed to protect the average daily
        wage earner from this danger take the budgetary backseat.
      </div>
      <div className='description'>
        To address the need for a healthcare coverage that will assure the
        average working man that in case he unexpectedly becomes ill or is
        injured both the financial and medical aspect of his problem is taken
        care of, Getwell Health Systems, Inc., an investor-based Health
        Maintenance Organization (HMO), was born.
      </div>
      <div className='description'>
        A corporation with a paid-up capital of P15 Million Pesos and an
        authorized capitalization of P60 Million Pesos, Getwell Health Systems,
        Inc., belongs to a business conglomerate composed of companies which are
        leaders in the service industry and employ a nationwide workforce of
        5,000 men and women. Starting with his readymade membership base,
        Getwell Health Systems, Inc., has since established itself as a
        determined new player in the healthcare industry.
      </div>
      <div className='description'>
        Adopting a corporate policy of affordability, personalized service and
        prompt payment of bills, Getwell Health Systems, Inc., intends to
        rapidly gain acceptance among members of the working class as well as
        the best health care providers in the country ensuring its place in an
        industry that still in its infancy. Through this policy, Getwell Health
        Systems, Inc., hopes to touch the lives of Filipino families everywhere,
        especially the most needy.
      </div>
    </div>
  );
};

export default CompanyProfile;
